// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contact_layout__yEOFC {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.9fr);
  gap: var(--space-4);
  align-items: start;
}

.Contact_channels__w5LlU {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}

.Contact_sidebar__NxSwK {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}

.Contact_cardHidden__5Rt7w {
  display: none;
}

.Contact_cardVisible__qaURm {
  display: flex;
}

.Contact_form__BkGhR {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.Contact_charCount__u\\+493 {
  text-align: right;
  margin-top: calc(-1 * var(--space-1));
}

.Contact_charCountLow__ROOxA {
  color: var(--warning);
  font-weight: 600;
}

.Contact_formFooter__1zsMy {
  display: flex;
  margin-top: var(--space-1);
}

.Contact_submit__Li4He {
  min-width: 200px;
}

@media (max-width: 820px) {
  .Contact_layout__yEOFC {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 480px) {
  .Contact_submit__Li4He {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Contact.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(280px, 0.9fr);\n  gap: var(--space-4);\n  align-items: start;\n}\n\n.channels {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  min-width: 0;\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  min-width: 0;\n}\n\n.cardHidden {\n  display: none;\n}\n\n.cardVisible {\n  display: flex;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n.charCount {\n  text-align: right;\n  margin-top: calc(-1 * var(--space-1));\n}\n\n.charCountLow {\n  color: var(--warning);\n  font-weight: 600;\n}\n\n.formFooter {\n  display: flex;\n  margin-top: var(--space-1);\n}\n\n.submit {\n  min-width: 200px;\n}\n\n@media (max-width: 820px) {\n  .layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .submit {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `Contact_layout__yEOFC`,
	"channels": `Contact_channels__w5LlU`,
	"sidebar": `Contact_sidebar__NxSwK`,
	"cardHidden": `Contact_cardHidden__5Rt7w`,
	"cardVisible": `Contact_cardVisible__qaURm`,
	"form": `Contact_form__BkGhR`,
	"charCount": `Contact_charCount__u+493`,
	"charCountLow": `Contact_charCountLow__ROOxA`,
	"formFooter": `Contact_formFooter__1zsMy`,
	"submit": `Contact_submit__Li4He`
};
export default ___CSS_LOADER_EXPORT___;
